import { useEffect, useState } from 'react';
import { HocuspocusProvider } from '@hocuspocus/provider';
import { useAppDispatch } from 'app/store';
import * as Y from 'yjs';
import { getLyrics2ConnectionEffect } from 'app/store/SongList/effects';

interface UseProviderProps {
  connectionLink?: {
    href: string;
    token: string;
  };
  songAttrs: {
    songGuid: string;
    songName: string;
  };
}

export const useProvider = ({
  connectionLink,
  songAttrs,
}: UseProviderProps) => {
  const { href, token } = connectionLink || {};
  const [yDoc, setYDoc] = useState<Y.Doc>();
  const [provider, setProvider] = useState<HocuspocusProvider>();
  const [synced, setSynced] = useState(false);
  const dispatch = useAppDispatch();

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (href && token) {
      const yDoc = new Y.Doc();
      const websocketProvider = new HocuspocusProvider({
        url: href,
        name: '',
        document: yDoc,
        parameters: { token },
      });
      websocketProvider.on('synced', () => {
        setSynced(true);
      });

      websocketProvider.on('close', async (props) => {
        if (!props.event.wasClean) {
          const response = await dispatch(
            getLyrics2ConnectionEffect(songAttrs)
          ).unwrap();
          websocketProvider.setConfiguration({
            url: response.connect.href,
            parameters: { token: response.connect.token },
          });
        }
      });

      if (window) {
        window.removeEventListener(
          'beforeunload',
          websocketProvider.boundBeforeUnload
        );
      }

      setYDoc(yDoc);
      setProvider(websocketProvider);

      return () => {
        websocketProvider.destroy();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [href, token]);

  return { provider, yDoc, synced };
};
